import { clampAmt } from "./calc";
import { AssetSelect, EntrySelect } from "./Selects";
import { Result } from "./Result";

export function SinglePosition({ assets, testid, assetId, asset, entry, pickAsset, setEntryId, amount, setAmount }) {
  return (
    <div className="grid lg:grid-cols-2 gap-8 items-start">
      <div className="space-y-5">
        <div>
          <span className="t-label">Company</span>
          <div className="mt-2"><AssetSelect assets={assets} value={assetId} onChange={pickAsset} tid={`${testid}-asset`} /></div>
          {asset?.sublabel && <p className="t-cap text-muted-s mt-2">{asset.sublabel}</p>}
        </div>
        <div>
          <span className="t-label">If you had entered at</span>
          <div className="mt-2"><EntrySelect a={asset} value={entry?.id} onChange={setEntryId} tid={`${testid}-entry`} /></div>
        </div>
        <div>
          <span className="t-label">Amount invested</span>
          <input className="input-solera fig mt-2" type="number" min={1000} step={1000} value={amount}
            onChange={(e) => setAmount(clampAmt(Number(e.target.value)))} data-testid={`${testid}-amount`} />
          <input type="range" min={1000} max={5000000} step={1000} value={amount}
            onChange={(e) => setAmount(Number(e.target.value))} className="w-full mt-3 accent-[#C69A4E]" data-testid={`${testid}-slider`} />
        </div>
      </div>
      <Result amount={amount} entry={entry} testid={testid} />
    </div>
  );
}
